import { createFileRoute } from '@tanstack/react-router'
import EmployeeConsumption from '@/features/employee-portal/pages/EmployeeConsumption'

export const Route = createFileRoute('/_authenticated/employee-portal/consumption')({
  component: EmployeeConsumption,
})
